import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import './Assets/scss/style.scss';
import Header from './Layout/Header';
import Index from './Public/Index';
import Login from './User/Login';
import Overview from './Private/Overview';
import PrivateRoutes from './Config/PrivateRoutes';
import { Toaster } from 'react-hot-toast';
import HelpAi from './Public/Ai/HelpAi';
import Coding from './Public/Coding';
import AboutPage from './Public/About';
import GradientMeker from './Tools/Gradients/GradientMeker';
import ColosTool from './Tools/Gradients/ColosTool';
import Task from './Public/TaskManager/Task';
import BlogPage from './Public/BlogPage';
import License from './Public/License';
import Footer from './Layout/Footer';
import Demo3 from './Public/Demo3';
import ReactSvg from './Tools/SVG/ReactSvg';
import Codes from './Private/Codes';
import SvgPath from './SvgPath';
import AiColor from './Tools/colorAi/AiColor';
import Randomcolor from './Tools/colorAi/Randomcolor';
import ToolHeader from './Layout/ToolHeader';
import GlassmorphismGenerator from './Tools/colorAi/GlassmorphismGenerator';
import BgSvg from './Tools/SVG/BgSvg';
import PreviewTools from './Tools/PreviewTools';
import Notes from './Tools/Notes';
// designing creatives


function App() {




    // Public page.....
    function PublicLayout() {
        return (
            <>
                <Header />
                <Outlet />
                <Footer />
            </>
        );
    }

    function PrivateLayout() {
        return (
            <>
                <Header />
                <Outlet />
                <Footer />
            </>
        );
    }


    // Login page.....
    function LoginLayout() {
        return (
            <Outlet />
        );
    }

    function SvgTools() {
        return (
            <div className='__active-tool'>
                <Header />
                <Outlet />
            </div>
        );
    }

    function CodeLayout() {
        return (
            <div className='__active-tool'>
                <Outlet />
            </div>
        );
    }

    function Tools() {
        return (
            <>
                <ToolHeader />
                <Outlet />
                <Footer />
            </>
        );
    }



    return (

        <Router>
            <Routes>
                <Route element={<LoginLayout />}>
                    <Route path='/login' element={<Login />} />
                </Route>


                <Route element={<PublicLayout />}>
                    <Route path='/' element={<Index />} />
                    <Route path='/about' element={<AboutPage />} />
                    <Route path='/license' element={<License />} />
                    <Route path='/tools' element={<PreviewTools />} />
                    <Route path='/websites' element={<HelpAi />} />
                    <Route path='/code' element={<Coding />} />
                    <Route path='/notes' element={<Notes />} />
                    <Route path='/blog' element={<BlogPage />} />
                    <Route path='/gradients' element={<GradientMeker />} />
                    <Route path='/colors' element={<ColosTool />} />



                    
                    
                   
                    <Route path='/task' element={<Task />} />
                    <Route path='/view' element={<Overview />} />
                    <Route path='/lines' element={<SvgPath />} />
                    
                    {/* <Route path='/jk2ss' element={<Demouij2 />} /> */}
                    {/* <Route path='/live' element={<Live />} /> */}
                </Route>

                <Route element={<Tools />}>
                    <Route path='/aicolor' element={<AiColor />} />
                    <Route path='/unique-color' element={<Randomcolor />} />
                    <Route path='/tool/svg-backgrounds' element={<BgSvg />} />
                    <Route path='/kl33' element={<GlassmorphismGenerator />} />
                </Route>


                <Route element={<SvgTools />}>
                    <Route path='/react-svg' element={<ReactSvg />} />
                </Route>


                <Route element={<PrivateLayout />}>
                    <Route element={<PrivateRoutes />}>
                        <Route path='/demo3' element={<Demo3 />} />
                    </Route>
                </Route>


                <Route element={<CodeLayout />}>
                    <Route path='/codes' element={<Codes />} />
                </Route>


               




            </Routes>
            <Toaster />
        </Router>


    );
}

export default App;